import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#632DE9", // Your primary color
      contrastText: "#FFFFFF", // White text for better readability
    },
    secondary: {
      main: "#4A1FB8", // A slightly darker shade for secondary color
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif", // Customize if needed
  },
});

export default theme;
